module.exports = __webpack_public_path__ + "assets/img/chef-3.3c3f2cfe.jpg";